import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.css";

ReactDOM.render(
    // commenting strict mode as its messes with react-google-map refresh
    // for ref: https://github.com/tomchentw/react-google-maps/issues/959#issuecomment-459684263
    // <React.StrictMode>
    <App />,
    // </React.StrictMode>,
    document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
